import backToTop from "./backToTop.component";

const backToTopModule = angular
  .module("app.components.backToTop", [])
  .component("backToTop", backToTop);

export default backToTopModule;



// WEBPACK FOOTER //
// ./src/components/backToTop/backToTop.module.js